import { useState } from 'react';

interface AppStoreBadgeProps {
  variant?: 'primary' | 'secondary';
  className?: string;
}

export default function AppStoreBadge({ variant = 'primary', className = '' }: AppStoreBadgeProps) {
  const [showModal, setShowModal] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <>
      {/* Official Mac App Store Badge */}
      <button
        onClick={handleClick}
        className={`inline-block transition-all duration-300 hover:scale-105 ${className}`}
        aria-label="Download on the Mac App Store (Coming Soon)"
      >
        <img 
          src="/mac-app-store-badge.svg" 
          alt="Download on the Mac App Store" 
          className="h-[60px] w-auto drop-shadow-lg"
        />
      </button>

      {/* Coming Soon Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in"
          onClick={() => setShowModal(false)}
        >
          <div
            className="glass-elevated rounded-3xl p-10 max-w-md mx-6 animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <img 
                  src="/app-icon.png" 
                  alt="SwiftDev Toolkit" 
                  className="w-24 h-24 rounded-2xl shadow-2xl"
                />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Coming Soon to the Mac App Store</h3>
              <p className="text-slate-400 mb-6 leading-relaxed">
                SwiftDev Toolkit is currently in development. We're working hard to bring you the best iOS build dashboard for macOS.
              </p>
              <p className="text-sm text-slate-500 mb-8">
                Want early access? Email us at{' '}
                <a
                  href="mailto:hello@swiftdevtoolkit.com"
                  className="text-brand-400 hover:text-brand-300 transition-colors font-medium hover:underline"
                >
                  hello@swiftdevtoolkit.com
                </a>
              </p>
              <button
                onClick={() => setShowModal(false)}
                className="group relative rounded-xl bg-brand-600 px-8 py-3 text-base font-semibold text-white hover:bg-brand-500 transition-all duration-300 hover:scale-105"
              >
                Got it
                <div className="absolute inset-0 rounded-xl bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
